import React from 'react';
import { ContentHeadline } from '../../../_lib/components/ContentHeadline';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { DateRanger } from '../../../components/molecules/DateRanger/DateRanger';
import ILink from '../../../types/ILink';
import { CategoryLabel } from '../../../_lib/components/CategoryLabel';
import { ICategory } from '../../../types/ICategory';

export type UpcomingEvent = {
  pageLink: ILink;
  eventStartDate: string;
  eventEndDate: string;
  allDayEvent: boolean;
  multiDayEvent: boolean;
  categories?: ICategory[];
  // there are events without owner, e.g. events in free rubrics
  owner?: ILink;
};

export function UpcomingEvent({
  pageLink,
  eventStartDate,
  eventEndDate,
  owner,
  categories,
  allDayEvent = true,
  multiDayEvent = true,
}: UpcomingEvent) {
  return (
    <article>
      <CategoryLabel className="upcoming-event__category font-regular-13-13" categories={categories} />
      <ContentHeadline url={pageLink.url} title={pageLink.name} />
      <div className="font-regular-14-19">
        <p className="upcoming-event__date-container">
          <DateRanger
            start={eventStartDate}
            end={eventEndDate}
            multiDayEvent={multiDayEvent}
            allDayEvent={allDayEvent}
          />
        </p>
        {owner && (
          <Hyperlink to={owner.url} className="upcoming-event__link">
            {owner.name}
          </Hyperlink>
        )}
      </div>
    </article>
  );
}
